<div [style.color]="'var(--color-primary)'">
  <svg
    [attr.width]="width"
    [attr.height]="height"
    viewBox="0 0 13 15"
    xmlns="http://www.w3.org/2000/svg"
    [style.opacity]="opacity"
  >
    <!-- Gradient ONLY if colors exist -->
    @if(hasGradient){
    <defs>
      <linearGradient
        [attr.id]="gradientId"
        gradientUnits="userSpaceOnUse"
        x1="0"
        y1="0"
        x2="13"
        y2="15"
      >
        <stop offset="0%" [style.stop-color]="startColor" />
        <stop offset="100%" [style.stop-color]="endColor" />
      </linearGradient>
    </defs>
    }

    <path
      d="M4.24047 12.4991H1.44111C1.05848 12.4248 0.711087 12.226 0.452835 11.9338C0.194583 11.6416 0.0399288 11.2723 0.0128572 10.8831C-0.0160714 9.5431 0.0128572 6.01739 0.0128572 6.01739C-0.00580857 5.72351 0.0392818 5.42908 0.145076 5.1543C0.250871 4.87953 0.414829 4.63093 0.625706 4.42559C1.31326 3.87815 4.94484 0.520122 4.94484 0.520122C5.09111 0.35649 5.27021 0.225576 5.47048 0.135954C5.67074 0.0463317 5.88765 0 6.10702 0C6.32639 0 6.54329 0.0463317 6.74356 0.135954C6.94382 0.225576 7.12292 0.35649 7.26919 0.520122C8.5185 1.71466 11.5614 4.30102 11.5614 4.30102C11.5614 4.30102 12.2792 4.57036 12.2927 6.01674C12.3062 7.46311 12.2927 10.6521 12.2927 10.6521C12.2927 10.6521 12.3108 12.5214 10.787 12.4998C9.26325 12.4783 8.23595 12.4998 8.23595 12.4998V8.56809C8.23595 8.56809 8.36041 7.46243 7.4125 7.46445C6.46458 7.46647 4.94484 7.46445 4.94484 7.46445C4.94484 7.46445 4.27206 7.5392 4.23977 8.56809C4.20748 9.59698 4.24047 12.4991 4.24047 12.4991Z"
      [attr.fill]="hasGradient ? 'url(#' + gradientId + ')' : defaultColor"
    />
  </svg>
</div>
